import React from 'react';
import { connect } from "react-redux";
import { compose } from 'redux'
import {withRouter } from "react-router-dom"
import { fetchData } from "../../actions/headerActions";
import HeaderDesktop from './HeaderDesktop';
import '../../styles/Header.css';
import HeaderTablet from './HeaderTablet';
import cartLogo from '../../assets/SVG-Global_Homepage_ProductHome_PLP_FreeTrial/Icon - Cart - Blue.svg';
import Cookies from 'js-cookie';
import {goToSearchPage,userTypingInNavSearch,navSearchFocusOut,
  addingUpDownEnterEventListenerToNavSearch} from '../SearchPageComponent/SearchText';
import GlobalAlertBanner from '../GlobalAlertComponent/GlobalAlert';
import $ from 'jquery';
import { getGeolocation } from '../../MENA_Country';
import { Link } from 'react-router-dom';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      searchToggle: true,
      width: window.innerWidth,
      isScrolled: false,
      reRendered: false
    };
  }

  componentDidMount() {
    // eslint-disable-next-line no-undef
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    global.preview = urlParams.get('preview');
    global.id = urlParams.get('page_id');
    
    this.props.dispatch(fetchData("home"));
    window.addEventListener('resize', this.handleWindowSizeChange);
    // to reflect cart count in main header instantly without page refresh(start)
    if(this.state.width <= 991 || window.location.pathname.includes("partner"))
      window.addEventListener('scroll', this.handleScroll);
    else
      window.removeEventListener('scroll', this.handleScroll);
    //end
    setTimeout(() => {this.applyEvent()},1000);
    if(!Cookies.get('geolocation')){
      getGeolocation();
    }
  }
  componentDidUpdate(prevProps){
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.setState({reRendered: true, active: false})
      this.props.blurBackground(true);
    }
  }
  
  applyEvent = () => {
    $(document).on('hidden.bs.modal', function () {
        $('[id^=viewVideoModal]').each((i,val) => {
            $(`#${val.id} iframe`).attr("src", $(`#${val.id} iframe`).attr("src"));
        })
    })
  }
  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };
  handleScroll = () => {
    this.setState({ isScrolled: true})
  }

  handleBlur = () => {
    this.setState({
      active: !this.state.active,
      searchToggle: true
    })
    this.props.blurBackground(this.state.active);
  }

  handleSearch = () => {
    this.textInput.focus();
    this.setState(() => ({
      searchToggle: !this.state.searchToggle,
      active: false
    }))
    this.props.blurBackground(true);
  }

  keyEventHandler = (event) => {
    addingUpDownEnterEventListenerToNavSearch(event);
  }

  render() {
    const { error, headerData } = this.props;
    const { header } = headerData.items;
    let isTablet = null;
    
    let pathname = window.location.pathname;
    let urlsplit = pathname.split("/");
    let pathContains = false;
    let productsArray = ['cpa','cma','cia','aicpa','pmp','aws-csa','comptia-a-plus','comptia-network-plus','comptia-security-plus','cfa',
    'caia','cmt','frm','securities','investment-banking','cima','cfp','gmat','act','advancedplacement','accounting','comptia-pentest',
    'comptia-project','caia-curriculum','finance','fmi','blockchain'];
    urlsplit.forEach(urlPart => {
      if(productsArray.includes(urlPart)){
        pathContains = true;
      }
    })
    
    if(header){
      global.cartUrl = header["top-header-menu"].menu.cart_url;
      global.loginUrl = header["top-header-menu"].menu.log_in_url;
      global.accountUrl = header["top-header-menu"].menu.my_account_url;
      global.callUsUrl = header["top-header-menu"].menu.call_us;
      global.modalContent1 = header["top-header-menu"].menu.model_content_1;
      global.modalContent2 = header["top-header-menu"].menu.model_content_2;
      global.citizenMaxValue = header["top-header-menu"].menu.citizen_max_threshold_value;
      global.citizenMinValue = header["top-header-menu"].menu.citizen_threshold_value;
    }

    if(pathContains && this.state.width < 992){
      isTablet = true;
    }

    if (error) {
      return (
        <div>
          Error!
          {error.message}
        </div>
      );
    }
	
    return (
      header !== undefined
      && (
      <>
      <section>
        {navigator.userAgent!=="ReactSnap" &&
        (!Cookies.get('user-closed-the-alert', {domain: '.efficientlearning.com'}) ||
        !Cookies.get('consentManagementComponentValue', {domain: '.efficientlearning.com'})
        ) &&
          <GlobalAlertBanner/>
        }
        <nav className={`navbar navbar-expand-lg navbar-light ${pathContains? "top-header-inproduct" : "top-header"} header-shadow`}>
          {/* title search login starts */}
          <Link className="navbar-brand brand-logo-top-desktop" to="/">
            <img
              src={header["top-header-menu"].menu.logo}
              height="auto"
              width="253px"
              title="Wiley Efficient Learning" alt="Wiley Efficient Learning"
            />
          </Link>
          <Link className="navbar-brand brand-logo-top-mobile" to="/">
            <img
              src={header["top-header-menu"].menu.logo_mobile}
              height="54px"
              width="68px"
              title="Wiley Efficient Learning" alt="Wiley Efficient Learning"
            />
          </Link>

          <div className="d-flex ml-auto tablet-menus special-menus xs-responsive">
            <div className="p-1 pr-2 tablet-seach-container">
              <form className="form-inline my-2 my-lg-0 searchbar">
                <span className={`fa ${this.state.searchToggle?"fa-search":"fa-times fa-lg"} icon-color`} aria-hidden="true"
                onClick={this.handleSearch.bind(this)} />
              </form>
            </div>
            <div className="p-2 mr-0">
              {' '}
              <a href={global.cartUrl} className="cart-link" aria-label="checkout">
                <img src={cartLogo} height="18px" width="20px" alt="cart"></img>
                <span className="cart-badge">{Cookies.get('wel-cart-total-items', {domain: '.efficientlearning.com'})}</span>
              </a>
            </div>
        
            <div className="pt-1 pl-1 mr-xs-1 mr-sm-4">
              {' '}
              <button
                className="navbar-toggler"
                id="openSidebar"
                type="button"
                aria-controls="navbarNavAltMarkup"
                aria-label="Toggle navigation"
                onClick={this.handleBlur.bind(this)}
              >
                <span className={`icon-color ${!this.state.active ? "fa fa-bars" : "fa fa-times-circle"}`} style={{ height: "24px", width: "24px" }} />
              </button>
            </div>
          </div>
          {/* title search login ends */}

          {/* menu starts */}
          <div className="navbar-collapse">
            <HeaderDesktop showProductLink={this.props.location.pathname} pathContains={pathContains} data={header["top-header-menu"]} />
            <HeaderTablet showProductLink={this.props.location.pathname} pathContains={pathContains} active={this.state.active} data={header["top-header-menu"]} />
          </div>
          {/* menu ends  */}
          <div className="d-flex ml-auto desktop-menus special-menus">
            {(this.props.location.pathname === "/" || !pathContains) &&
            <>
            <div className="p-2 mr-1 desktop-search-container">
              <form className="form-inline my-2 my-lg-0 searchbar">
                <i className={`fa ${this.state.searchToggle?"fa-search":"fa-times fa-lg"} icon-color`}
                aria-hidden="true" onClick={this.handleSearch.bind(this)} />
              </form>
            </div>
            <div className="p-1 pr-2 desktop-cart-container">
              {' '}
              <a href={global.cartUrl} className="cart-link" aria-label="checkout">
                <img src={cartLogo} height="18px" width="20px" alt="cart"/>
                <span className="cart-badge">{Cookies.get('wel-cart-total-items', {domain: '.efficientlearning.com'})}</span>
              </a>
            </div>
            </>}
            <div className={`p-2 pr-5 ${this.props.location.pathname === "/" || !pathContains && 'login-nav-desktop'}`}>
              {' '}
              {(Cookies.get('user-oauth-token', {domain: '.efficientlearning.com'}) ||
              Cookies.get('user-logged-in', {domain: '.efficientlearning.com'}))?
              <a href={global.accountUrl} className="icon-color nav-login" aria-label="account">ACCOUNT</a>:
              <a href={global.loginUrl} className="icon-color nav-login" aria-label="login">LOG IN</a>}
            </div>
            {/* search page url navigation link for react snap so it can create page for build. */}
            <div className="d-none">
            <a href="/search" className="d-none" aria-label="search">Search</a>
            </div>
          </div>
        </nav>
        {(!pathContains || isTablet) &&
        <>
            <div className={`search-bar ${this.state.searchToggle?"search-closed":"search-open"}
            ${isTablet?"main-header-search-bar":""}`}>
              <div className="container-fluid">
                  <div className="row justify-content-center">
                      <div className="col-md-11 d-flex flex-row-reverse">
                          <div className="col-12 col-md-7 col-lg-3">
                              <div className="form-group">
                                  <div className="input-group">
                                      <input type="text" className="form-control border-0"
                                      id="inputSearch" placeholder="Search" ref={(input) => { this.textInput = input; }}
                                      onKeyDown={this.keyEventHandler} onInput={()=>{userTypingInNavSearch()}}
                                      onBlur={()=>{navSearchFocusOut()}} name="search" aria-label="Search"/>
                                      <div className="input-group-append">
                                          <button type="button" className="btn srch-btn" id="searchbutton"
                                          onClick={()=>{goToSearchPage()}} name="search" aria-labelledby="searchbutton">
                                            <i className="fa fa-search"aria-hidden="true"></i>
                                          </button>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
            </div>
            <div className="search-bar-autocomplete">
              <div className="container-fluid">
                  <div className="row justify-content-center">
                      <div className="col-md-11 d-flex flex-row-reverse">
                          <div className="col-12 col-md-7 col-lg-3">
                              <div className="position-relative">
                                  <div className={`search-bar-autocomplete-container ${isTablet?"top-height":""}`}>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          </>
          }
        </section>
      </>
      )
    );
  }
}
const mapStateToProps = (state) => ({
  headerData: state.HeaderFooterData,
  error: state.HeaderFooterData.error,
});

export default compose(
  withRouter,
  connect(mapStateToProps)
)(Header);